/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
function QueuesSummaryViewController ($timeout, $location, BreadcrumbService, QueuesViewService, NavbarUtilService) {
	var self = this;
	var defaultProps = {chartData: {series: [], data: []}, width: 500, height: 250};
	var loadDataTimeout = null;

	var loadQueueSummaries = function () {
		self.loadingIndicator.show = true;
		$timeout.cancel(loadDataTimeout);

		QueuesViewService.loadSummaryData().then(function (summaryData) {
			self.transcodesProps.chartData = summaryData.transcodes;
			self.deliveriesProps.chartData = summaryData.deliveries;
			self.restoresProps.chartData = summaryData.restores;
			self.fileCopyProps.chartData = summaryData.fileCopy;
			loadDataTimeout = $timeout(loadQueueSummaries, 15000);
			self.loadingIndicator.show = false;
		});
	};

	self.openQueueGroupSummaryView = function (group) {
		BreadcrumbService.updateBreadcrumbs({name: 'Queues Summary', location: '/dashboard/queues/summary'});
		QueuesViewService.showFinishedDataInGraph = self.showFinished;
		$location.url('/dashboard/queues/summary/' + group);
	};

	NavbarUtilService.viewSearchFunction = loadQueueSummaries;

	self.transcodesProps = angular.copy(defaultProps);
	self.deliveriesProps = angular.copy(defaultProps);
	self.restoresProps = angular.copy(defaultProps);
	self.fileCopyProps = angular.copy(defaultProps);

	self.loadingIndicator = {
		backdrop: true,
		show: false,
		title: 'Working',
		message: 'Please wait...'
	};

	self.reloadQueuesFromShowFinishedChange = function () {
		QueuesViewService.showFinishedDataInGraph = self.showFinished;
		loadQueueSummaries();
	};

	self.$onInit = function () {
		self.showFinished = QueuesViewService.showFinishedDataInGraph;
		loadQueueSummaries();
	};

	self.$onDestroy = function () {
		NavbarUtilService.viewSearchFunction = null;
		$timeout.cancel(loadDataTimeout);
		loadDataTimeout = null;
	};
}

angular.module('prism-ui.queues').component('queuesSummaryView', {
	templateUrl: 'dashboard/queues/summary/queues-summary-view-template.html',
	controller: QueuesSummaryViewController
});
